export const style = {
  section: {
    padding: `60px 0`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/DashboardContainer/style/main.js